import { HukButton } from "huk-react-bindings";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { getAppEnv } from "env/env";
import { pcPostApi } from "shared/apiEndpoints";
import { axiosPostInstance } from "../../../../shared/axiosInstance";
 
export function extractArrayItems(arrayOrObject) {
  if (arrayOrObject && Array.isArray(arrayOrObject)) {
    const result = [];
    for (let i = 0; i < arrayOrObject.length; i++) {
      const item = arrayOrObject[i];
      const obj = {};
      for (const key in item) {
        if (Object.prototype.hasOwnProperty.call(item, key) &&
         item[key] !== null &&
         item[key] !== undefined &&
         item[key] !== "") {
          obj[key] = item[key];
        }
      }
      if (Object.keys(obj).length > 0) {
        result.push(obj);
      }
    }
    return result;
  } else if (arrayOrObject && typeof arrayOrObject === "object") {
    return arrayOrObject;
  } else {
    return [];
  }
}
 
export function nestedObjectToArray(dataArray) {
  if (!Array.isArray(dataArray)) {
    if (typeof dataArray === "object" && dataArray !== null) {
      dataArray = [dataArray];
    } else {
      return [];
    }
  }
  return dataArray.map(item => {
    const formattedItem = {};
    Object.entries(item).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        formattedItem[key] = String(value);
      }
    });
    return formattedItem;
  }).filter(item => Object.keys(item).length > 0);
}
 
const PolicyCenter = ({ searchData, reportData, stateConcernItem,
  messageItem }) => {
    const [searchParams] = useSearchParams();
    const searchParam = {
      SourceSystemIdentifier: searchParams.get("SourceSystemIdentifier") ?? null,
      AccountNumber: searchParams.get("AccountNumber") ?? null,
      Browser: searchParams.get("Browser") ?? null,
      WCCOBId: searchParams.get("WCCOBId") ?? null,
      SICCode: searchParams.get("SICCode") ?? null,
      SICDescription: searchParams.get("SICDescription") ?? null,
      MSICode: searchParams.get("MSICode") ?? null,
      MSIDescription: searchParams.get("MSIDescription") ?? null,
      WCStateCode: searchParams.get("WCStateCode") ?? null,
      WCClassCode: searchParams.get("WCClassCode") ?? null,
      WCClassDescriptionCode: searchParams.get("WCClassDescriptionCode") ?? null,
      COBId: searchParams.get("COBId") ?? null
    };
 
  //1.save to Policy Center activity
  const handlePCClick = async () => {
    const AccountNumber = sessionStorage.getItem("accountNumber");
    const policyCenterApiPayload = {
      AccountNumber: AccountNumber,
      SourceSystemIdentifier: searchParam.SourceSystemIdentifier,
      Browser: searchParam.Browser,
      WCCOBId: searchParam.WCCOBId,
      SICCode: searchParam.SICCode,
      SICDescription: searchParam.SICDescription,
      MSICode: searchParam.MSICode,
      MSIDescription: searchParam.MSIDescription,
      WCStateCode: searchParam.WCStateCode,
      WCClassCode: searchParam.WCClassCode,
      WCClassDescriptionCode: searchParam.WCClassDescriptionCode,
      COBId: searchParam.COBId,
      searchResultsLineItemList: nestedObjectToArray(searchData),
      stateConcernItem: extractArrayItems(stateConcernItem),
      messageItem: extractArrayItems(messageItem),
      associatedWCCodes: extractArrayItems(reportData?.associatedWCCodes),
      associatedPropertyCodes: extractArrayItems(reportData?.associatedPropertyCodes),
      associatedSICCodes: extractArrayItems(reportData?.associatedSICCodes),
      submitIndicators: extractArrayItems(reportData?.submitIndicators),
      coverageInstructions: extractArrayItems(reportData?.coverageInstructions),
      underwriterInstructions: extractArrayItems(reportData?.underwriterInstructions),
      underwritingQuestions: extractArrayItems(reportData?.underwritingQuestions),
      agencyInstructions: extractArrayItems(reportData?.agencyInstructions),
      forms: extractArrayItems(reportData?.forms),
      associatedWCCodesDetail: extractArrayItems(reportData?.associatedWCCodesDetail),
      targetMSICodes: extractArrayItems(reportData?.targetMSICodes),
      rateTierFactors: extractArrayItems(reportData?.rateTierFactors),
      bestsArticles: extractArrayItems(reportData?.bestsArticles),
      supportingInformation: extractArrayItems(reportData?.supportingInformation),
      otherSingleLinks: extractArrayItems(reportData?.otherSingleLinks),
      uwExposureQuestions: extractArrayItems(reportData?.uwExposureQuestions),
      commonWCCodes: extractArrayItems(reportData?.commonWCCodes),
    };
    console.log("wcCodes", extractArrayItems(reportData?.commonWCCodes?.[0]?.classCode));
     function removeEmptyArrays(obj) {
      const newObj = {};
     
      Object.entries(obj).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            newObj[key] = value;  // Keep non-empty arrays
          }
        } else if (value && typeof value === 'object') {
          newObj[key] = removeEmptyArrays(value); // Recurse into nested objects
        } else {
          newObj[key] = value;  // Keep primitives
        }
      });
     
      return newObj;
    }
     
    const cleanedPayload = removeEmptyArrays(policyCenterApiPayload);
 
    console.log("array", Array.isArray(policyCenterApiPayload.targetMSICodes));
    console.log("reportData", reportData);
    console.log("AccountNumber", localStorage.getItem("accountNumber"));
    console.log("PolicyCenter Payload", policyCenterApiPayload);
    console.log("cleanedPayload", cleanedPayload);
    const pcUrl = `${getAppEnv().POLICYCENTER_DOMAIN}`;
 
    try {
      const response = await axiosPostInstance()
        .post(pcPostApi, cleanedPayload)
     
      if (response.status === 200 || response.data.status === "ok") {
        //window.open(pcUrl, "_blank");
       window.location.href = pcUrl;
       window.close();
      }
      console.log("response.status", response.status);
    } catch (err) {
      alert(err.response.data.message);
    }
  };
 
  //2.exit page
  const handleExit = () => {
    //window.open('about:blank', '_self');
   window.close();
  };
 
  return (
    <div className="policy_center p-0 d-md-flex justify-content-md-end">
      <div className="px-1 py-1">
        <HukButton
          type="button"
          text="Save to Policy Center"
          hukclass="btn-primary btn-xs"
          data-testid="SaveToPolicyCenterButtonID"
          data-dl={`{"da_track": "true", "event_id": "Save to Policy Center"}`}
          onClick={() => {
            handlePCClick();
          }}
        />
      </div>
 
      <div className="px-1 py-1">
        <HukButton
          type="button"
          text="Exit"
          hukclass="btn-primary btn-xs"
          data-testid="ExitButtonID"
          data-dl={`{"da_track": "true", "event_id": "Exit"}`}
          onClick={() => {
            handleExit();
          }}
        />
      </div>
    </div>
  );
};
 
export default PolicyCenter;
 
